import { render } from "./footer.vue?vue&type=template&id=290946bc"
const script = {}

import "./footer.vue?vue&type=style&index=0&id=290946bc&lang=css"

import exportComponent from "X:\\Proyecto\\riego-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__